import { Link } from "react-router-dom";
import { seoArticlesList } from "@/mocks/seoArticlesList";

export default function SEOArticlesGrid() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <p className="font-heading text-xs md:text-sm text-foreground-500 italic font-medium">
            Knowledge Base
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mt-2">
            Sourcing Guides
            <br />
            <span className="font-script text-primary-500 italic font-semibold">
              & Insights
            </span>
          </h2>
          <p className="text-sm text-foreground-600 mt-4 max-w-lg">
            Expert-written articles to help you master product sourcing, discover trends, and scale your eCommerce business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {seoArticlesList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-transform hover:-translate-y-1"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500">{article.datePublished}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{article.author}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-semibold hover:border-foreground-950 hover:text-foreground-950 transition-colors whitespace-nowrap"
          >
            View All Guides
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}